import * as React from "react";

export const nameToPath = (name: string): string => name.replace(/\s/g, "").toLocaleLowerCase();

export const projectAnchor = (projectName: string): JSX.Element => (
  <a href={`/#/${nameToPath(projectName)}`}>{projectName}</a>
);
